export enum SectionGap {
    None = 'none',
    Small = 'small',
    Base = 'base',
    Large = 'large',
}

export enum SectionStretch {
    Small = 'small',
    Medium = 'medium',
}

export const INVITES_URL_PARAM = 'inviteCode';
export const INVITES_URL_GROUP_PARAM = 'groupId';
